/* Regex taken from https://github.com/eventbrite/payment-service-client-py/blob/master/payment_service_client/utils/payment.py */
import {
    AmexPayment,
    BancontactPayment,
    CmrPayment,
    DiscoverPayment,
    EloPayment,
    HipercardPayment,
    MaestroPayment,
    MastercardDebitPayment,
    MastercardPayment,
    MercadopagoPayment,
    NaranjaPayment,
    NativaPayment,
    VisaDebitPayment,
    VisaPayment,
} from '@eventbrite/eds-iconography';
import { fromPairs } from 'lodash';
import React, { ReactNode } from 'react';

const CARD_NUMBER_REGEX_DISCOVER =
    '(?:6011[0-9]{12}|622(?:12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5])[0-9]{10}|64[4-9][0-9]{13}|65[0-9]{14})$';
const CARD_NUMBER_PREFIX_REGEX_DISCOVER =
    '^(?:6011[0-9]{12}|622(?:12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5])[0-9]{10}|64[4-9][0-9]|65[0-9])';

const CARD_NUMBER_REGEX_ELO =
    '^((?:50670[7-8])|506715|(?:50671[8-9])|(?:50672[0-1])|(?:50672[4-9])|(?:50673[0-3])|506739|(?:50674[1-3])|(?:50674[5-7])|506753|(?:50677[4-8])|(?:50900[0-2])|(?:50900[4-7])|509009|(?:50901[0-2])|509014|(?:50902[0-9])|509030|(?:50903[5-9])|(?:50904[0-2])|(?:50904[4-9])|(?:50905[0-9])|(?:50906[0-4])|(?:50906[6-9])|(?:50907[0-2])|(?:50907[4-9])|(?:50908[0-9])|(?:50909[1-2])|(?:50909[5-9])|(?:50910[0-1])|(?:50910[6-9])|(?:50911[0-9])|(?:50912[0-9])|(?:50913[0-9])|(?:50914[0-9])|(?:50915[0-9])|(?:50916[0-9])|(?:50917[0-9])|(?:50918[0-9])|(?:50919[0-9])|(?:50920[0-9])|(?:50921[0-9])|(?:50922[0-9])|(?:50923[0-9])|(?:50924[0-9])|(?:50925[0-9])|(?:50926[0-9])|(?:50927[0-9])|(?:50928[0-9])|(?:50929[0-9])|(?:50930[0-9])|(?:50931[0-9])|(?:50932[0-9])|(?:50933[0-9])|(?:50934[0-9])|(?:50935[0-9])|(?:50936[0-9])|(?:50937[0-9])|(?:50938[0-9])|(?:50939[0-9])|(?:50940[0-9])|(?:50941[0-9])|(?:50942[0-9])|(?:50943[0-9])|(?:50944[0-9])|(?:50945[0-9])|(?:50946[0-9])|(?:50947[0-9])|(?:50948[0-9])|(?:50949[0-9])|(?:50950[0-9])|(?:50951[0-9])|(?:50952[0-9])|(?:50953[0-9])|(?:50954[0-9])|(?:50955[0-9])|(?:50956[0-9])|(?:50957[0-9])|(?:50958[0-9])|(?:50959[0-9])|(?:50960[0-9])|(?:50961[0-9])|(?:50962[0-9])|(?:50963[0-9])|(?:50964[0-9])|(?:50965[0-9])|(?:50966[0-9])|(?:50967[0-9])|(?:50968[0-9])|(?:50969[0-9])|(?:50970[0-9])|(?:50971[0-9])|(?:50972[0-9])|(?:50973[0-9])|(?:50974[0-9])|(?:50975[0-9])|(?:50976[0-9])|(?:50977[0-9])|(?:50978[0-9])|(?:50979[0-9])|(?:50980[0-7])|(?:50983[1-9])|(?:50984[0-9])|(?:50985[0-9])|(?:50986[0-9])|(?:50987[0-7])|(?:50989[7-9])|509900|(?:50991[8-9])|(?:50992[0-9])|(?:50993[0-9])|(?:50994[0-9])|(?:50995[0-9])|(?:50996[0-4])|(?:50997[1-9])|(?:50998[0-6])|(?:50999[5-9])|636368|(?:65040[6-9])|(?:65041[0-9])|(?:65042[0-9])|(?:65043[0-9])|(?:65048[5-9])|(?:65049[0-9])|(?:65050[0-4])|(?:65050[6-9])|(?:65051[0-9])|(?:65052[0-9])|(?:65053[0-8])|(?:65055[2-9])|(?:65056[0-9])|(?:65057[0-9])|(?:65058[0-9])|(?:65059[0-8])|(?:65072[0-7])|(?:65090[1-9])|(?:65091[0-9])|(?:65092[0-2])|650928|650939|(?:65094[6-9])|(?:65095[0-9])|(?:65096[0-9])|(?:65097[0-8])|(?:65165[2-9])|(?:65166[0-9])|(?:65167[0-9])|(?:65168[0-9])|(?:65169[0-9])|(?:65170[0-4])|(?:65500[0-9])|(?:65501[0-9])|(?:65502[1-9])|(?:65503[0-9])|(?:65504[0-9])|(?:65505[0-7]))[0-9]{10}$';
const CARD_NUMBER_PREFIX_REGEX_ELO =
    '^((?:50670[7-8])|506715|(?:50671[8-9])|(?:50672[0-1])|(?:50672[4-9])|(?:50673[0-3])|506739|(?:50674[1-3])|(?:50674[5-7])|506753|(?:50677[4-8])|(?:50900[0-2])|(?:50900[4-7])|509009|(?:50901[0-2])|509014|(?:50902[0-9])|509030|(?:50903[5-9])|(?:50904[0-2])|(?:50904[4-9])|(?:50905[0-9])|(?:50906[0-4])|(?:50906[6-9])|(?:50907[0-2])|(?:50907[4-9])|(?:50908[0-9])|(?:50909[1-2])|(?:50909[5-9])|(?:50910[0-1])|(?:50910[6-9])|(?:50911[0-9])|(?:50912[0-9])|(?:50913[0-9])|(?:50914[0-9])|(?:50915[0-9])|(?:50916[0-9])|(?:50917[0-9])|(?:50918[0-9])|(?:50919[0-9])|(?:50920[0-9])|(?:50921[0-9])|(?:50922[0-9])|(?:50923[0-9])|(?:50924[0-9])|(?:50925[0-9])|(?:50926[0-9])|(?:50927[0-9])|(?:50928[0-9])|(?:50929[0-9])|(?:50930[0-9])|(?:50931[0-9])|(?:50932[0-9])|(?:50933[0-9])|(?:50934[0-9])|(?:50935[0-9])|(?:50936[0-9])|(?:50937[0-9])|(?:50938[0-9])|(?:50939[0-9])|(?:50940[0-9])|(?:50941[0-9])|(?:50942[0-9])|(?:50943[0-9])|(?:50944[0-9])|(?:50945[0-9])|(?:50946[0-9])|(?:50947[0-9])|(?:50948[0-9])|(?:50949[0-9])|(?:50950[0-9])|(?:50951[0-9])|(?:50952[0-9])|(?:50953[0-9])|(?:50954[0-9])|(?:50955[0-9])|(?:50956[0-9])|(?:50957[0-9])|(?:50958[0-9])|(?:50959[0-9])|(?:50960[0-9])|(?:50961[0-9])|(?:50962[0-9])|(?:50963[0-9])|(?:50964[0-9])|(?:50965[0-9])|(?:50966[0-9])|(?:50967[0-9])|(?:50968[0-9])|(?:50969[0-9])|(?:50970[0-9])|(?:50971[0-9])|(?:50972[0-9])|(?:50973[0-9])|(?:50974[0-9])|(?:50975[0-9])|(?:50976[0-9])|(?:50977[0-9])|(?:50978[0-9])|(?:50979[0-9])|(?:50980[0-7])|(?:50983[1-9])|(?:50984[0-9])|(?:50985[0-9])|(?:50986[0-9])|(?:50987[0-7])|(?:50989[7-9])|509900|(?:50991[8-9])|(?:50992[0-9])|(?:50993[0-9])|(?:50994[0-9])|(?:50995[0-9])|(?:50996[0-4])|(?:50997[1-9])|(?:50998[0-6])|(?:50999[5-9])|636368|(?:65040[6-9])|(?:65041[0-9])|(?:65042[0-9])|(?:65043[0-9])|(?:65048[5-9])|(?:65049[0-9])|(?:65050[0-4])|(?:65050[6-9])|(?:65051[0-9])|(?:65052[0-9])|(?:65053[0-8])|(?:65055[2-9])|(?:65056[0-9])|(?:65057[0-9])|(?:65058[0-9])|(?:65059[0-8])|(?:65072[0-7])|(?:65090[1-9])|(?:65091[0-9])|(?:65092[0-2])|650928|650939|(?:65094[6-9])|(?:65095[0-9])|(?:65096[0-9])|(?:65097[0-8])|(?:65165[2-9])|(?:65166[0-9])|(?:65167[0-9])|(?:65168[0-9])|(?:65169[0-9])|(?:65170[0-4])|(?:65500[0-9])|(?:65501[0-9])|(?:65502[1-9])|(?:65503[0-9])|(?:65504[0-9])|(?:65505[0-7]))';

const CARD_NUMBER_REGEX_HIPERCARD =
    '^((606282)|(637095)|(637568)|(637599)|(637609)|(637612))[0-9]{10}$';
const CARD_NUMBER_PREFIX_REGEX_HIPERCARD =
    '^((606282)|(637095)|(637568)|(637599)|(637609)|(637612))[0-9]';

const CARD_NUMBER_REGEX_MAESTRO_BANCONTACT = '^6703[0-9]{12,15}$';
const CARD_NUMBER_PREFIX_REGEX_MAESTRO_BANCONTACT = '^6703';

const CARD_NUMBER_REGEX_NARANJA = '^(589562)[0-9]{10}$';
const CARD_NUMBER_PREFIX_REGEX_NARANJA = '^(589562)';

const CARD_NUMBER_REGEX_NATIVA =
    '^((520053)|(546553)|(554472)|(531847)|(527601))[0-9]{10}$';
const CARD_NUMBER_PREFIX_REGEX_NATIVA =
    '^((520053)|(546553)|(554472)|(531847)|(527601))';

const CARD_NUMBER_REGEX_AMEX = '^3[47][0-9]{13}$';
const CARD_NUMBER_PREFIX_REGEX_AMEX = '^3[47]';

const CARD_NUMBER_REGEX_MASTERCARD =
    '^(?:2(?:22[1-9]|2[3-9][0-9]|[3-6][0-9]{2}|7[0-1][0-9]|720)[0-9]{12}|36[0-9]{12}|5[1-5][0-9]{14})$';
const CARD_NUMBER_PREFIX_REGEX_MASTERCARD =
    '^(?:2(?:22[1-9]|2[3-9][0-9]|[3-6][0-9]{2}|7[0-1][0-9]|720)|36[0-9]|5[1-5][0-9])';

const CARD_NUMBER_REGEX_VISA = '^4[0-9]{12}(?:[0-9]{3})?$';
const CARD_NUMBER_PREFIX_REGEX_VISA = '^4';

const CARD_NUMBER_REGEX_CMR = '^(557039)[0-9]{10}$';
const CARD_NUMBER_PREFIX_REGEX_CMR = '^(557039)';

const CARD_NUMBER_REGEX_MERCADO_PAGO =
    '^((515073)|(515070)|(532384))[0-9]{10}$';
const CARD_NUMBER_PREFIX_REGEX_MERCADO_PAGO = '^((515073)|(515070)|(532384))';

const CARD_NUMBER_REGEX_VISA_DEBIT =
    '^(490889|409230|410352|476940|454970|420884|400276|400448|400615|400930|402789|402914|404022|404625|405069|405511|405515|405516|405517|405755|405896|405897|406165|406190|406191|406192|406193|406194|406195|406196|406290|406291|406375|406652|406998|406999|408134|408515|410082|410083|410121|410122|410123|410853|411197|411199|411849|412944|413180|416679|416861|417309|417856|417857|421518|421528|421541|421738|423001|423018|423077|423090|423465|423613|423613|423623|424968|424969|426618|427156|427157|428062|428063|428064|429751|429752|431070|431071|434531|434532|434533|434534|434535|434536|434537|434538|434539|434540|434541|434542|434543|434549|434550|434586|434795|437996|437999|438050|438051|438844|439818|441046|442371|442548|443264|444047|444060|444267|444268|444493|446343|446344|446345|446346|446347|448712|450412|450799|450811|451377|451701|451751|451756|451757|451758|451761|451763|451764|451765|451766|451767|451768|451769|451770|451772|451773|452132|452133|453770|455890|457308|457596|457664|457665|459300|462815|463465|464855|468508|469283|469874|472041|472042|473227|473365|473710|473711|473712|473713|473714|473715|473716|473717|473718|473719|473720|473721|473722|473725|474531|476520|477051|477053|477169|478017|478527|478601|480459|480460|480724|480860|481397|481501|481502|481550|483002|483020|483188|485089|485947|486547|486587|486621|486665|487221|488241|489412|489634|492499|492528|492596|492597|492598|499859|400819|480062|476840|474174|434798|422671|425983|433454|425984|491282|491089|483030|421316|474176|430967|480078|476588|491365|491580|491567|491566|442192|418928|490256|477961|477261|477177|476890|476687|446986|446985|490950|473993|469495|466397|467596|400889|441549|441545|429522|405930|476684|449700|449187|408340|446115|441312|498587|455509|446117|446116|411808|408343|481517|446118|408341|481516|455537|455533|455510|410177|455511|441313|415231|409851|491566|416916|418914|407612|435769|428464|477130|465762|413098|432049|446878|400820|445016|445017|469693|460700|460766|400195|412432|415269|421364|402766|419821|480066|480076|457386|483104|483112|419822|419823|457249|408400|421003|426188|485043|485044|400443|410128|465828|465829|492143|407848|426808|465495|465496|465497|465498|444888|444889|491344|481279|405063|413131|419334|419335|438099|459497|462278|460068|474646|479303|422299|471239|457476|412294|420807|498588|498590)[0-9]{10}$';
const CARD_NUMBER_PREFIX_REGEX_VISA_DEBIT =
    '^(490889|409230|410352|476940|454970|420884|400276|400448|400615|400930|402789|402914|404022|404625|405069|405511|405515|405516|405517|405755|405896|405897|406165|406190|406191|406192|406193|406194|406195|406196|406290|406291|406375|406652|406998|406999|408134|408515|410082|410083|410121|410122|410123|410853|411197|411199|411849|412944|413180|416679|416861|417309|417856|417857|421518|421528|421541|421738|423001|423018|423077|423090|423465|423613|423613|423623|424968|424969|426618|427156|427157|428062|428063|428064|429751|429752|431070|431071|434531|434532|434533|434534|434535|434536|434537|434538|434539|434540|434541|434542|434543|434549|434550|434586|434795|437996|437999|438050|438051|438844|439818|441046|442371|442548|443264|444047|444060|444267|444268|444493|446343|446344|446345|446346|446347|448712|450412|450799|450811|451377|451701|451751|451756|451757|451758|451761|451763|451764|451765|451766|451767|451768|451769|451770|451772|451773|452132|452133|453770|455890|457308|457596|457664|457665|459300|462815|463465|464855|468508|469283|469874|472041|472042|473227|473365|473710|473711|473712|473713|473714|473715|473716|473717|473718|473719|473720|473721|473722|473725|474531|476520|477051|477053|477169|478017|478527|478601|480459|480460|480724|480860|481397|481501|481502|481550|483002|483020|483188|485089|485947|486547|486587|486621|486665|487221|488241|489412|489634|492499|492528|492596|492597|492598|499859|400819|480062|476840|474174|434798|422671|425983|433454|425984|491282|491089|483030|421316|474176|430967|480078|476588|491365|491580|491567|491566|442192|418928|490256|477961|477261|477177|476890|476687|446986|446985|490950|473993|469495|466397|467596|400889|441549|441545|429522|405930|476684|449700|449187|408340|446115|441312|498587|455509|446117|446116|411808|408343|481517|446118|408341|481516|455537|455533|455510|410177|455511|441313|415231|409851|491566|416916|418914|407612|435769|428464|477130|465762|413098|432049|446878|400820|445016|445017|469693|460700|460766|400195|412432|415269|421364|402766|419821|480066|480076|457386|483104|483112|419822|419823|457249|408400|421003|426188|485043|485044|400443|410128|465828|465829|492143|407848|426808|465495|465496|465497|465498|444888|444889|491344|481279|405063|413131|419334|419335|438099|459497|462278|460068|474646|479303|422299|471239|457476|412294|420807|498588|498590)';

const CARD_NUMBER_REGEX_MASTERCARD_DEBIT =
    '^(512834|511673|555889|551314|526497|524313|522684|559926|559109|559100|557917|551200|541409|539110|536671|536670|536560|533888|533871|533860|533423|531179|531141|530779|522128|518787|515845|505865|505864|505863|232004|559219|557069|555902|554630|552999|550480|549807|547883|542755|542744|542734|538172|537067|536196|532309|531984|531441|530815|530561|530516|528824|527341|525562|525337|523793|522713|522428|519879|519020|516656|512258|511658|511657|501108|501107|501104|501092|230937|230933|230895|230867|230724|230709|230688|230570|526461|514365|514256|514586|525855|511309|514285|553839|553777|553771|551792|528733|549180|528745|517562|511849|557648|546367|502121|559471|506270|506229|518847|530686|526424|516594|511114|506340|557551|506228|517439|517440|549613|517747|554628|504563|529093|517771|557991|551077|557561|550233|533609|551244|554627|504536|557875|557874|529028|525678|524711|520698|520694|520416|520116|517795|517721|517712|558426|554492|551081|557910|557909|557908|557907|557905|506217|545730|506218|589617|557906|506221|523595|506273|506199|506305|506306|506307|506332|506333|588772|528430|551440|516016|524021|506269|535943|537030|526476|554964|506341|506323|551238|506259|529571|526354|539955|553467|516576|528074|534381|557604|506236|506257|532485|512280|516102|506250|506255|506304|526498|506212|539975|530113|506416|506414|550897|506392|506204|506249|529575|506201|506205|511265|538984|553800|554173|506275|557602|551515|523691|502275|506206|526192|526194|526196|526197|551507|551509|506415|511761|506383|506374|506402|506335|506265|535900|539944|506314|506411|506313|506245|506251|506386|526404|506274|506258|506353|506350|555924|506355|506410|506423|506424|506361|506247|506284|506352|506263|506432|506297|506287|506334|506364|506384|506320|506319|506344|506294|506283|506342|506282|506421|506393|506343|506439|506373|536783|549685|506367|506303|506254|506413|533922|516611|506337|506397|506398|506213|506277|506278|506279|506280|506377|511852|506422|506312|506441|506399|537938|506427|510586|538405|538088|506214|506215|506356|528480|506389|506351|506300|506354|506253|546378|516415|506309|533987|534926|545290|545325|506311|506365|506380|506407|557920|557921|557922|557923|557924|506412|528598|531294|549672|506391|506428|511765|543924|506302|506429|506449|526400|551353|506405|506406)[0-9]{10}$';
const CARD_NUMBER_PREFIX_REGEX_MASTERCARD_DEBIT =
    '^(512834|511673|555889|551314|526497|524313|522684|559926|559109|559100|557917|551200|541409|539110|536671|536670|536560|533888|533871|533860|533423|531179|531141|530779|522128|518787|515845|505865|505864|505863|232004|559219|557069|555902|554630|552999|550480|549807|547883|542755|542744|542734|538172|537067|536196|532309|531984|531441|530815|530561|530516|528824|527341|525562|525337|523793|522713|522428|519879|519020|516656|512258|511658|511657|501108|501107|501104|501092|230937|230933|230895|230867|230724|230709|230688|230570|526461|514365|514256|514586|525855|511309|514285|553839|553777|553771|551792|528733|549180|528745|517562|511849|557648|546367|502121|559471|506270|506229|518847|530686|526424|516594|511114|506340|557551|506228|517439|517440|549613|517747|554628|504563|529093|517771|557991|551077|557561|550233|533609|551244|554627|504536|557875|557874|529028|525678|524711|520698|520694|520416|520116|517795|517721|517712|558426|554492|551081|557910|557909|557908|557907|557905|506217|545730|506218|589617|557906|506221|523595|506273|506199|506305|506306|506307|506332|506333|588772|528430|551440|516016|524021|506269|535943|537030|526476|554964|506341|506323|551238|506259|529571|526354|539955|553467|516576|528074|534381|557604|506236|506257|532485|512280|516102|506250|506255|506304|526498|506212|539975|530113|506416|506414|550897|506392|506204|506249|529575|506201|506205|511265|538984|553800|554173|506275|557602|551515|523691|502275|506206|526192|526194|526196|526197|551507|551509|506415|511761|506383|506374|506402|506335|506265|535900|539944|506314|506411|506313|506245|506251|506386|526404|506274|506258|506353|506350|555924|506355|506410|506423|506424|506361|506247|506284|506352|506263|506432|506297|506287|506334|506364|506384|506320|506319|506344|506294|506283|506342|506282|506421|506393|506343|506439|506373|536783|549685|506367|506303|506254|506413|533922|516611|506337|506397|506398|506213|506277|506278|506279|506280|506377|511852|506422|506312|506441|506399|537938|506427|510586|538405|538088|506214|506215|506356|528480|506389|506351|506300|506354|506253|546378|516415|506309|533987|534926|545290|545325|506311|506365|506380|506407|557920|557921|557922|557923|557924|506412|528598|531294|549672|506391|506428|511765|543924|506302|506429|506449|526400|551353|506405|506406)';

export enum CardTypeName {
    AMEX = 'AMEX',
    CMR = 'CMR',
    DISCOVER = 'DISCOVER',
    ELO = 'ELO',
    HIPERCARD = 'HIPERCARD',
    MAESTRO = 'MAESTRO',
    MAESTRO_BANCONTACT = 'MAESTRO_BANCONTACT',
    MASTERCARD = 'MASTERCARD',
    MASTERCARD_DEBIT = 'MASTERCARD_DEBIT',
    MERCADO_PAGO = 'MERCADO_PAGO',
    NARANJA = 'NARANJA',
    NATIVA = 'NATIVA',
    VISA = 'VISA',
    VISA_DEBIT = 'VISA_DEBIT',
}

export const CARD_TYPE_AMEX = CardTypeName.AMEX;
export const CARD_TYPE_CMR = CardTypeName.CMR;
export const CARD_TYPE_DISCOVER = CardTypeName.DISCOVER;
export const CARD_TYPE_ELO = CardTypeName.ELO;
export const CARD_TYPE_HIPERCARD = CardTypeName.HIPERCARD;
export const CARD_TYPE_MAESTRO = CardTypeName.MAESTRO;
export const CARD_TYPE_MAESTRO_BANCONTACT = CardTypeName.MAESTRO_BANCONTACT;
export const CARD_TYPE_MASTERCARD = CardTypeName.MASTERCARD;
export const CARD_TYPE_MASTERCARD_DEBIT = CardTypeName.MASTERCARD_DEBIT;
export const CARD_TYPE_MERCADO_PAGO = CardTypeName.MERCADO_PAGO;
export const CARD_TYPE_NARANJA = CardTypeName.NARANJA;
export const CARD_TYPE_NATIVA = CardTypeName.NATIVA;
export const CARD_TYPE_VISA = CardTypeName.VISA;
export const CARD_TYPE_VISA_DEBIT = CardTypeName.VISA_DEBIT;

export type CardType =
    | '001'
    | '002'
    | '003'
    | '004'
    | '005'
    | '006'
    | '007'
    | '008'
    | '009'
    | '010'
    | '012'
    | '014'
    | '015'
    | '024';

export const CARD_TYPES: Record<CardType, CardTypeName> = {
    '001': CardTypeName.VISA,
    '002': CardTypeName.MASTERCARD,
    '003': CardTypeName.AMEX,
    '004': CardTypeName.DISCOVER,
    '005': CardTypeName.MAESTRO_BANCONTACT,
    '006': CardTypeName.NARANJA,
    '007': CardTypeName.NATIVA,
    '008': CardTypeName.MERCADO_PAGO,
    '009': CardTypeName.HIPERCARD,
    '010': CardTypeName.ELO,
    '012': CardTypeName.VISA_DEBIT,
    '014': CardTypeName.MAESTRO,
    '015': CardTypeName.MASTERCARD_DEBIT,
    '024': CardTypeName.CMR,
};

export const AVAILABLE_CARD_TYPES = Object.values(CARD_TYPES);

export const getCardTypeByName = (cardTypeName: CardTypeName): CardType => {
    const getKeyByValue = (
        object: Record<CardType, CardTypeName>,
        value: CardTypeName,
    ): CardType =>
        Object.keys(object).find(
            (key) => object[key as CardType] === value,
        ) as CardType;

    return getKeyByValue(CARD_TYPES, cardTypeName);
};

export interface RegexBasedCardValidation {
    prefixRegex: string;
    regex: string;
}

export interface PrefixAndLengthBasedCardValidation {
    prefixes: Array<number>;
    lengths: Record<number, boolean>;
}

type WithCardValidation =
    | RegexBasedCardValidation
    | PrefixAndLengthBasedCardValidation;

export type CardDefinition = WithCardValidation & {
    cardType: CardType;
    name: string;
    maxLength: number;
    icon: ReactNode;
    securityCodeName?: string;
};

/**
 * This card definitions should include either prefixes (the card should start for those numbers) + lengths
 * and regex to support more complex expressions.
 * Order matters. Include more specific definition first and more generic in the end of the list.
 * Eg. Visa matches with anything which starts with 4, but ELO includes some cards which also starts with 4.
 * cardType should match with
 * https://github.com/eventbrite/core/blob/ae780bb7d04b0418d2eea70f53b659b10d35c409/django/src/www/eventbrite/common/soa/payment_service/__init__.py#L52-L78
 */
export const CARD_DEFINITIONS: Array<CardDefinition> = [
    {
        cardType: getCardTypeByName(CardTypeName.CMR),
        name: CardTypeName.CMR.toLowerCase(),
        prefixRegex: CARD_NUMBER_PREFIX_REGEX_CMR,
        regex: CARD_NUMBER_REGEX_CMR,
        maxLength: 16,
        icon: <CmrPayment />,
        securityCodeName: 'CVV',
    },
    {
        cardType: getCardTypeByName(CardTypeName.DISCOVER),
        name: CardTypeName.DISCOVER.toLowerCase(),
        prefixRegex: CARD_NUMBER_PREFIX_REGEX_DISCOVER,
        regex: CARD_NUMBER_REGEX_DISCOVER,
        maxLength: 19,
        icon: <DiscoverPayment />,
        securityCodeName: 'CID',
    },
    {
        cardType: getCardTypeByName(CardTypeName.ELO),
        name: CardTypeName.ELO.toLowerCase(),
        prefixRegex: CARD_NUMBER_PREFIX_REGEX_ELO,
        regex: CARD_NUMBER_REGEX_ELO,
        maxLength: 16,
        icon: <EloPayment />,
        securityCodeName: 'CSC',
    },
    {
        cardType: getCardTypeByName(CardTypeName.HIPERCARD),
        name: CardTypeName.HIPERCARD.toLowerCase(),
        prefixRegex: CARD_NUMBER_PREFIX_REGEX_HIPERCARD,
        regex: CARD_NUMBER_REGEX_HIPERCARD,
        maxLength: 16,
        icon: <HipercardPayment />,
        securityCodeName: 'CSC',
    },
    {
        cardType: getCardTypeByName(CardTypeName.NARANJA),
        name: CardTypeName.NARANJA.toLowerCase(),
        prefixRegex: CARD_NUMBER_PREFIX_REGEX_NARANJA,
        regex: CARD_NUMBER_REGEX_NARANJA,
        maxLength: 16,
        icon: <NaranjaPayment />,
        securityCodeName: 'CVV',
    },
    {
        cardType: getCardTypeByName(CardTypeName.MAESTRO),
        name: CardTypeName.MAESTRO.toLowerCase(),
        prefixes: [50, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69],
        lengths: {
            12: true,
            13: true,
            14: true,
            15: true,
            16: true,
            17: true,
            18: true,
            19: true,
        },
        maxLength: 19,
        icon: <MaestroPayment />,
        securityCodeName: 'CVC',
    },
    {
        cardType: getCardTypeByName(CardTypeName.MAESTRO_BANCONTACT),
        name: CardTypeName.MAESTRO_BANCONTACT.toLowerCase(),
        prefixRegex: CARD_NUMBER_PREFIX_REGEX_MAESTRO_BANCONTACT,
        regex: CARD_NUMBER_REGEX_MAESTRO_BANCONTACT,
        maxLength: 18,
        icon: <BancontactPayment />,
    },
    {
        cardType: getCardTypeByName(CardTypeName.MASTERCARD_DEBIT),
        name: CardTypeName.MASTERCARD_DEBIT.toLowerCase(),
        prefixRegex: CARD_NUMBER_PREFIX_REGEX_MASTERCARD_DEBIT,
        regex: CARD_NUMBER_REGEX_MASTERCARD_DEBIT,
        maxLength: 16,
        icon: <MastercardDebitPayment />,
        securityCodeName: 'CVC',
    },
    {
        cardType: getCardTypeByName(CardTypeName.MERCADO_PAGO),
        name: CardTypeName.MERCADO_PAGO.toLowerCase(),
        prefixRegex: CARD_NUMBER_PREFIX_REGEX_MERCADO_PAGO,
        regex: CARD_NUMBER_REGEX_MERCADO_PAGO,
        maxLength: 16,
        icon: <MercadopagoPayment />,
        securityCodeName: 'CVV',
    },
    {
        cardType: getCardTypeByName(CardTypeName.NATIVA),
        name: CardTypeName.NATIVA.toLowerCase(),
        prefixRegex: CARD_NUMBER_PREFIX_REGEX_NATIVA,
        regex: CARD_NUMBER_REGEX_NATIVA,
        maxLength: 16,
        icon: <NativaPayment />,
        securityCodeName: 'CVV',
    },
    {
        cardType: getCardTypeByName(CardTypeName.VISA_DEBIT),
        name: CardTypeName.VISA_DEBIT.toLowerCase(),
        prefixRegex: CARD_NUMBER_PREFIX_REGEX_VISA_DEBIT,
        regex: CARD_NUMBER_REGEX_VISA_DEBIT,
        maxLength: 16,
        icon: <VisaDebitPayment />,
        securityCodeName: 'CVV',
    },
    {
        cardType: getCardTypeByName(CardTypeName.AMEX),
        name: CardTypeName.AMEX.toLowerCase(),
        prefixRegex: CARD_NUMBER_PREFIX_REGEX_AMEX,
        regex: CARD_NUMBER_REGEX_AMEX,
        maxLength: 15,
        icon: <AmexPayment />,
        securityCodeName: 'CID',
    },
    {
        cardType: getCardTypeByName(CardTypeName.MASTERCARD),
        name: CardTypeName.MASTERCARD.toLowerCase(),
        prefixRegex: CARD_NUMBER_PREFIX_REGEX_MASTERCARD,
        regex: CARD_NUMBER_REGEX_MASTERCARD,
        maxLength: 16,
        icon: <MastercardPayment />,
        securityCodeName: 'CVC',
    },
    {
        cardType: getCardTypeByName(CardTypeName.VISA),
        name: CardTypeName.VISA.toLowerCase(),
        prefixRegex: CARD_NUMBER_PREFIX_REGEX_VISA,
        regex: CARD_NUMBER_REGEX_VISA,
        maxLength: 16,
        icon: <VisaPayment />,
        securityCodeName: 'CVV',
    },
];

const CARD_DEFINITIONS_BY_NAME = fromPairs(
    CARD_DEFINITIONS.map((cardDefinition) => [
        cardDefinition.name.toLowerCase(),
        cardDefinition,
    ]),
);
const CARD_DEFINITIONS_BY_CARD_TYPE = fromPairs(
    CARD_DEFINITIONS.map((cardDefinition) => [
        cardDefinition.cardType.toLowerCase(),
        cardDefinition,
    ]),
);

export const getCardDef = (cardNameOrType: CardType | CardTypeName) =>
    CARD_DEFINITIONS_BY_NAME[cardNameOrType.toLowerCase()] ||
    CARD_DEFINITIONS_BY_CARD_TYPE[cardNameOrType.toLowerCase()];

// This will verify that the date is in the format MM/YY, and that
// the month is in the range 01 - 12 (leading 0 optional).
export const EXPIRY_FORMAT_REGEX = /^(0?[1-9]|1[0-2])\/\d{2}$/;
